import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link} from "@material-ui/core"
import React, {useState} from "react"
import {injectIntl} from "react-intl"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"
import XsButton from "../../global/ui/xsButton/xsButton"
import {observer} from "mobx-react"
import ConsentSentDialogStore from "./ConsentSentDialogStore"
import RequestStore from "./requestStore"
import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"
import GlobalStore from "../../global/store/GlobalStore"

function ConsentSentDialog() {
	const hooks = {
		onSubmit() {},
		onSuccess(form) {
			RequestStore.sendRequest(form, ConsentSentDialogStore.requestId)
		},
		onError(form) {
			logger("CHYBY:", form.errors())
			GlobalStore.setNotificationMessage("Skontrolujte povinné polia", null, "error")
		}
	}

	const [form] = useState(
		new MobxReactForm(
			{
				fields: {
					consent: {
						label: "Beriem na vedomie spracúvanie poskytnutých osobných údajov",
						type: "checkbox",
						value: false
					}
				}
			},
			{plugins: {dvr: dvr(validatorjs)}, hooks}
		)
	)

	return (
		<Dialog
			id="createUniversalTemplate"
			open={ConsentSentDialogStore.isOpen}
			onClose={() => ConsentSentDialogStore.close(form)}
			className="xs-base-dialog"
			classes={{
				paper: "xs-paper-dialog xs-width-paper-900 fullWidth"
			}}
			disableBackdropClick={true}
			maxWidth="md"
		>
			<DialogTitle className="xs-info">
				<div className="xs-header">
					<div
						style={{position: "absolute", right: 24, top: 16, cursor: "pointer"}}
						onClick={() => {
							ConsentSentDialogStore.close(form)
						}}
					>
						<i className="fal fa-times fa-lg" />
					</div>
					<div className="xs-header-title">Spracúvanie osobných údajov</div>
				</div>
			</DialogTitle>
			<DialogContent>
				<Grid container className="pl-2 pt-4">
					<Grid item xs={12}>
						Spracúvanie osobných údajov:{" "}
						<Link
							className="pointer underline"
							onClick={() => window.open("https://www.siea.sk/o-siea/ochrana-osobnych-udajov/")}
						>
							https://www.siea.sk/o-siea/ochrana-osobnych-udajov/
						</Link>
					</Grid>
					<Grid item xs={12} className="pl-8 pt-4">
						<XsCheckbox field={form.$("consent")} labelVariant="button" />
					</Grid>
					<Grid item xs={12} className="pt-4 redDanger">
						Bez udelenia súhlasu so spracúvaním poskytnutých osobných údajov nie je možné žiadosť uložiť alebo odoslať.
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Grid item container justify="space-between" className="ma-4">
					<Grid item>
						<XsButton
							className="xs-primary"
							icon={<i className="fal fa-times " />}
							text="Zrušiť"
							onClick={() => ConsentSentDialogStore.close(form)}
						/>
					</Grid>
					<Grid item>
						<XsButton
							className="xs-primary"
							icon={<i className="fal fa-arrow-right" />}
							disabled={!form.$("consent").value}
							text="Pokračovať"
							onClick={(e) => form.onSubmit(e)}
						/>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	)
}

export default injectIntl(observer(ConsentSentDialog))

